export const KM_COMMON_TEST_IDS = {
    MAIN_NAVIGATION_MENU: "main-navigation-menu",
    NAV_LINKS: "km-nav-links",
    NAV_FAVORITES: "km-nav-favorites",
    NAV_APPLIED: "km-nav-applied",
    NAV_DISMISSED: "km-nav-dismissed",
    NAV_MESSAGES: "km-nav-messages",
    NAV_PREFERENCES: "km-nav-preferences",
    PROFILE_MENU_TRIGGER: "km-profile-menu-trigger",
    PROFILE_AVATAR: "km-profile-avatar",
    PROFILE_MENU: "km-profile-menu",
    PROFILE_MENU_PREFERENCES: "km-profile-menu-preferences",
    PROFILE_MENU_SETTINGS: "km-profile-menu-settings",
    PROFILE_MENU_MESSAGES: "km-profile-menu-messages",
    PROFILE_MENU_LOGOUT: "km-profile-menu-logout"
};

export const KM_COMMON_TEST_IDS_MOBILE = {
    TAB_NAVIGATION_MENU: "tab-navigation-menu-mobile",
    BOTTOM_NAV: "km-bottom-nav",
    BOTTOM_NAV_FAVORITES: "km-bottom-nav-favorites",
    BOTTOM_NAV_INQUIRIES: "km-bottom-nav-inquiries",
    BOTTOM_NAV_DISMISSED: "km-bottom-nav-dismissed"
};
export const KM_COMMON_TEST_IDS = {
    MAIN_NAVIGATION_MENU: "main-navigation-menu",
    NAV_LINKS: "km-nav-links",
    NAV_FAVORITES: "km-nav-favorites",
    NAV_APPLIED: "km-nav-applied",
    NAV_DISMISSED: "km-nav-dismissed",
    NAV_MESSAGES: "km-nav-messages",
    NAV_PREFERENCES: "km-nav-preferences",
    PROFILE_MENU_TRIGGER: "km-profile-menu-trigger",
    PROFILE_AVATAR: "km-profile-avatar",
    PROFILE_MENU: "km-profile-menu",
    PROFILE_MENU_PREFERENCES: "km-profile-menu-preferences",
    PROFILE_MENU_SETTINGS: "km-profile-menu-settings",
    PROFILE_MENU_MESSAGES: "km-profile-menu-messages",
    PROFILE_MENU_LOGOUT: "km-profile-menu-logout"
};

export const KM_COMMON_TEST_IDS_MOBILE = {
    TAB_NAVIGATION_MENU: "tab-navigation-menu-mobile",
    BOTTOM_NAV: "km-bottom-nav",
    BOTTOM_NAV_FAVORITES: "km-bottom-nav-favorites",
    BOTTOM_NAV_INQUIRIES: "km-bottom-nav-inquiries",
    BOTTOM_NAV_DISMISSED: "km-bottom-nav-dismissed"
};
